import axiosInstance from "../api/api";

/**
 * Checks if the current user has verified their email.
 * First checks local storage for a fast synchronous check. If it's false, it
 * double checks by fetching the latest profile data from the backend to ensure
 * the local storage isn't just stale (e.g. they verified it in another tab).
 *
 * @returns {Promise<boolean>} True if the email is verified, false otherwise.
 */
export const checkIsEmailVerified = async () => {
  let isVerified = localStorage.getItem("isVerified") === "true";

  if (!isVerified) {
    try {
      // Fetch latest to be absolutely sure
      const res = await axiosInstance.get("/profile/me");
      const latestUser = res.data?.user || res.data?.data;

      if (latestUser && latestUser.isVerified) {
        isVerified = true;
        localStorage.setItem("isVerified", "true");
      }
    } catch (err) {
      console.error("Failed to check verification status", err);
    }
  }

  return isVerified;
};

/**
 * Checks if the current user is a fully onboarded professional who has a dashboard.
 * @returns {boolean}
 */
export const isCompletedProfessional = () => {
  const token = localStorage.getItem("authToken");
  const role = localStorage.getItem("role");
  const onboardingComplete = localStorage.getItem("onboardingComplete");
  const professionalId = localStorage.getItem("professionalId");
  return Boolean(
    token &&
    role === "professional" &&
    (onboardingComplete === "true" || !!professionalId)
  );
};

/**
 * Checks if the current user is a professional who is logged in but has not finished onboarding.
 * @returns {boolean}
 */
export const isPendingProfessional = () => {
  const token = localStorage.getItem("authToken");
  const role = localStorage.getItem("role");
  const onboardingComplete = localStorage.getItem("onboardingComplete");
  const professionalId = localStorage.getItem("professionalId");
  return Boolean(
    token &&
    role === "professional" &&
    (onboardingComplete === "false" || !professionalId)
  );
};
